const getDocumentTitle = (url) => {
  if (url === null) return "";
  const parts = url.split("/");
  const filenameWithSuffix = parts[parts.length - 1];
  const filename = filenameWithSuffix.split("_")[0];
  return decodeURIComponent(filename);
};
export default getDocumentTitle;
